//import { DomainVerification } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import { collection, updateDoc, doc, getDocs } from "firebase/firestore";

function Landing() {
  const loginRef = collection(db, "adminLogin");
  const landingRef = collection(db, "landingtext");
  let loginDetailsDb;
  const [UsernameInput, setUsernameInput] = useState("");
  const [passInput, setPassInput] = useState("");
  const [passVerify, setPassVerify] = useState("");
  const [landingText, setLandingText] = useState([
    {
      id: "",
      text: "",
    },
  ]);
  const [landingInput, setLandinginput] = useState("");

  const getAdminLogin = async () => {
    const data = await getDocs(loginRef);
    const loginDetails = data.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    loginDetailsDb = loginDetails[0].id;
    setUsernameInput(loginDetails[0].username);
  };

  const getLandingText = async () => {
    const data = await getDocs(landingRef);
    setLandingText(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    const land = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    setLandinginput(land[0].text);
  };

  useEffect(() => {
    getAdminLogin();
    getLandingText();
  }, []);

  const passChangeHandler = (e, input) => {
    switch (input) {
      case "pass":
        setPassInput(e.target.value);
        break;
      case "verify":
        setPassVerify(e.target.value);
        break;
      default:
        alert("Error!");
    }
  };
  const updateLoginDb = async () => {
    const loginDoc = doc(db, "adminLogin", "Fudk6j0xse7MUgH6Z0jM");
    const loginInput = {
      username: UsernameInput,
      password: passInput,
    };
    await updateDoc(loginDoc, loginInput);
    alert("User Login Updated");
  };

  const updataeLandingText = async () => {
    const landingDoc = doc(db, "landingtext", landingText[0].id);
    const landingInputUpdate = {
      text: landingInput,
    };
    await updateDoc(landingDoc, landingInputUpdate);
    alert("Landing Page Text Updated");
  };

  const updateLogin = () => {
    passInput === passVerify
      ? updateLoginDb()
      : alert("Password Does Not Match!");
  };

  return (
    <React.Fragment>
      <div className="bg-white w-full h-full p-4 rounded-xl shadow-md flex flex-col gap-4 overflow-hidden">
        {/* Header */}
        <div className="border-l-4 border-sky-500 pl-3 flex-shrink-0">
          <h1 className="font-bold text-2xl text-slate-800">
            Landing Page and Basic Settings
          </h1>
          <p className="text-sm text-slate-400">
            Manage landing page content and administrator credentials
          </p>
        </div>

        {/* Content Area */}
        <div className="flex-1 min-h-0 overflow-y-auto px-1">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Left Column: Landing Page Text */}
            <div className="flex flex-col gap-4">
              <h2 className="text-lg font-semibold text-slate-700 border-b pb-2">
                Update Landing Page Text
              </h2>
              <div className="flex flex-col gap-1">
                <label
                  htmlFor="landingText"
                  className="text-xs font-semibold text-slate-500 uppercase tracking-wider"
                >
                  Content
                </label>
                <textarea
                  id="landingText"
                  className="w-full border border-slate-200 bg-slate-50 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400 resize-y"
                  rows="6"
                  value={landingInput}
                  onChange={(e) => setLandinginput(e.target.value)}
                ></textarea>
              </div>
              <button
                className="bg-sky-600 hover:bg-sky-700 active:bg-sky-800 text-white font-semibold rounded-lg py-2 px-4 transition-colors shadow-sm self-start"
                onClick={updataeLandingText}
              >
                Update Landing Text
              </button>
            </div>

            {/* Right Column: Login Details */}
            <div className="flex flex-col gap-4">
              <h2 className="text-lg font-semibold text-slate-700 border-b pb-2">
                Update Login Details
              </h2>
              <div className="flex flex-col gap-1">
                <label
                  htmlFor="username"
                  className="text-xs font-semibold text-slate-500 uppercase tracking-wider"
                >
                  Username
                </label>
                <input
                  id="username"
                  type="text"
                  className="w-full border border-slate-200 bg-slate-50 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
                  value={UsernameInput}
                  onChange={(e) => setUsernameInput(e.target.value)}
                />
              </div>
              <div className="flex flex-col gap-1">
                <label
                  htmlFor="password"
                  className="text-xs font-semibold text-slate-500 uppercase tracking-wider"
                >
                  New Password
                </label>
                <input
                  id="password"
                  type="password"
                  className="w-full border border-slate-200 bg-slate-50 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
                  value={passInput}
                  onChange={(e) => passChangeHandler(e, "pass")}
                  placeholder="Enter new password"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label
                  htmlFor="confirmPassword"
                  className="text-xs font-semibold text-slate-500 uppercase tracking-wider"
                >
                  Confirm New Password
                </label>
                <input
                  id="confirmPassword"
                  type="password"
                  className="w-full border border-slate-200 bg-slate-50 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400"
                  value={passVerify}
                  onChange={(e) => passChangeHandler(e, "verify")}
                  placeholder="Confirm new password"
                />
              </div>
              <button
                className="bg-sky-600 hover:bg-sky-700 active:bg-sky-800 text-white font-semibold rounded-lg py-2 px-4 transition-colors shadow-sm self-start"
                onClick={updateLogin}
              >
                Update Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Landing;
